import React, {Component} from 'react';
import PropTypes from 'prop-types';

class PlaceholderIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="18px"
          height="14px"
          viewBox="0 0 18 14"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-847.000000, -6853.000000)"
            >
              <g id="Model-Action-Icons" transform="translate(56.000000, 6308.000000)">
                <g id="row" transform="translate(0.000000, 501.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="model-actions-/-placeholder-/-Enabled,-Focus"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M11.9804688,16.1953125 L17.3320312,7.640625 L6.66796875,7.640625 L11.9804688,16.1953125 Z M11.9804688,19.3203125 L3.66015625,6 L20.3398438,6 L11.9804688,19.3203125 Z"
                        id="placeholder"
                        fill="currentColor"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

PlaceholderIcon.propTypes = {
  className: PropTypes.string,
};

export default PlaceholderIcon;
